'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconDefault = function IconDefault(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement('path', {
			d: 'M14.879 3.31a.867.867 0 0 0-1.493-.884c-.02.032-1.981 3.264-5.885 3.264-1.888 0-3.311-.744-4.287-1.522-.021-.016-.032-.04-.055-.055-.01-.007-.023-.007-.034-.013-.972-.798-1.472-1.609-1.511-1.674a.865.865 0 0 0-1.19-.304.866.866 0 0 0-.302 1.188c.04.07.487.797 1.34 1.62L.535 6.318A.962.962 0 0 0 .8 7.647a.962.962 0 0 0 1.329-.265l.844-1.263c.443.279.94.533 1.489.744l-.42 1.597a.96.96 0 0 0 .684 1.171.961.961 0 0 0 1.17-.683l.424-1.611c.378.052.767.089 1.18.089.266 0 .52-.017.772-.039l.43 1.636a.96.96 0 0 0 1.17.684v-.001a.96.96 0 0 0 .684-1.169L10.153 7a8.48 8.48 0 0 0 1.955-.935l.907 1.3a.96.96 0 0 0 1.333.239v-.001a.96.96 0 0 0 .239-1.334l-.98-1.406c.807-.795 1.23-1.485 1.272-1.553',
			fill: '#FFF',
			fillRule: 'evenodd'
		})
	);
};

IconDefault.defaultProps = {
	width: '15',
	height: '11',
	viewBox: '0 0 15 11',
	xmlns: 'http://www.w3.org/2000/svg'
};

var Closed = function (_React$Component) {
	_inherits(Closed, _React$Component);

	function Closed() {
		_classCallCheck(this, Closed);

		return _possibleConstructorReturn(this, (Closed.__proto__ || Object.getPrototypeOf(Closed)).apply(this, arguments));
	}

	_createClass(Closed, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(IconDefault, null);
		}
	}]);

	return Closed;
}(_react2.default.Component);

exports.default = Closed;